import { useGetAccountInfo } from '../../../hooks/event-store-hooks';
import { getAccountInfoLogo, HashType } from '@block-explorer/entities';
import {
  ACCOUNT_DETAILS_PATH,
  RouterPathsMap,
  SEARCH_PATH,
} from '../../../router/paths';

export interface getAccountDataFromHashProps {
  hash?: string | null;
  type?: string;
}

export type AccountDataType = {
  logo: string | null;
  name?: string;
  path: keyof RouterPathsMap;
  publicKey?: string | null;
};

export type AccountDataDeployActionType = {
  data: AccountDataType;
  loading: boolean;
};

export const useGetAccountDataFromHash = ({
  hash,
  type,
}: getAccountDataFromHashProps): AccountDataDeployActionType => {
  const { data: accountInfoData, loading: accountInfoLoading } =
    useGetAccountInfo(
      hash
        ? {
            accountHash: hash,
            includes: 'centralized_account_info,account_info',
          }
        : null
    );

  const accountInfo = accountInfoData?.data;
  const publicKey = accountInfo?.public_key;
  const logo = getAccountInfoLogo(accountInfo?.account_info);
  const name = accountInfo?.account_info?.info?.owner?.name;

  const path: keyof RouterPathsMap =
    type && type === HashType.accountHash ? ACCOUNT_DETAILS_PATH : SEARCH_PATH;

  return {
    data: {
      logo,
      name,
      path,
      publicKey,
    },
    loading: accountInfoLoading,
  };
};
